<script>
import MixedGridMediaItem from '@phoenix/mixins/components/mixedGrid/MixedGridMediaItem';
import PictureLazy from '@maison/components/common/PictureLazy';

export default {
  components: {
    PictureLazy,
  },

  mixins: [MixedGridMediaItem],

  props: {
    image: {
      type: Object,
      required: true,
    },
  },

  computed: {
    containerClasses() {
      return ['mixed-grid-card', { 'mixed-grid-card--large': this.size === 2 }].concat(this.displayClasses);
    },
  },
};
</script>

<template>
  <div :class="containerClasses">
    <div class="mixed-grid-card__picture">
      <div class="picture picture--cover">
        <picture-lazy v-bind="image" />
      </div>
    </div>
  </div>
</template>
